
import 'reset.scss/reset.scss'
import 'swiper/css'
import 'swiper/css/effect-fade'

import './scss/style.scss'

import $ from 'webpack-zepto'
import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

$(function(){
  /**
   * Nav Toggle
   */

  $('.js-nav-open').on('click', function(){
    $('#header').show()
  })

  $('.js-nav-close').on('click', function(){
    $('#header').hide()
  })

  $('.nav-list-primary a').on('click', function(){
    $('#header').hide()
  })

})

/**
 * Swiper Slide
 */

new Swiper('#facility-gallery', {
  loop: true,
  loopAdditionalSlides: 2,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  breakpoints: {
    480: {
      slidesPerView: 2.3,
    },
  }
})